import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield, CreditCard, AlertTriangle } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
const items = [{
  name: 'เล่มที่ 1 — รากฐานฟุตบอล',
  value: '500฿'
}, {
  name: 'เล่มที่ 2 — การควบคุมและความคล่อง',
  value: '500฿'
}, {
  name: 'เล่มที่ 3 — การส่งบอลและทีมเวิร์ค',
  value: '500฿'
}, {
  name: 'เล่มที่ 4 — ยุทธวิธีเบื้องต้น',
  value: '500฿'
}, {
  name: 'เล่มที่ 5 — ผลงานและความเข้มข้น',
  value: '500฿'
}, {
  name: 'เล่มที่ 6 — ปฏิทินการฝึกซ้อมทั้งปี',
  value: '500฿'
}, {
  name: '6 โบนัสพิเศษ',
  value: '2,400฿'
}];
export function Offer() {
  return <section id="offer" className="w-full bg-navy-primary py-20 px-4" data-id="element-159">
      <div className="max-w-4xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-gold-accent relative" data-id="element-161">
          {/* Discount Badge */}
          <div className="absolute top-6 right-6 bg-red-600 text-white px-6 py-3 rounded-full font-bold text-xl shadow-lg z-10" data-id="element-162">
            ลด 90%
          </div>

          <div className="bg-gradient-to-br from-gold-accent to-gold-light p-8 text-center" data-id="element-163">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-navy-primary mb-2" data-id="element-164">
              🏆 ตัวเลือกที่ได้รับความนิยมสูงสุด
            </h2>
          </div>

          <div className="p-8 md:p-12" data-id="element-165">
            <h3 className="text-2xl font-display font-bold text-navy-primary mb-6 text-center" data-id="element-166">
              มูลค่ารวมของเนื้อหาทั้งหมด:
            </h3>

            <div className="space-y-3 mb-8" data-id="element-167">
              {items.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-168">
                  <span className="text-gray-700" data-id="element-169">{item.name}</span>
                  <span className="font-bold text-navy-primary" data-id="element-170">
                    → {item.value}
                  </span>
                </div>)}
            </div>

            <div className="border-t-2 border-gray-300 pt-6 mb-8" data-id="element-171">
              <div className="flex justify-between items-center mb-4" data-id="element-172">
                <span className="text-xl font-bold text-gray-600" data-id="element-173">
                  มูลค่าจริง:
                </span>
                <span className="text-2xl font-bold text-gray-400 line-through" data-id="element-174">
                  5,900฿
                </span>
              </div>

              <div className="text-center my-8" data-id="element-175">
                <p className="text-2xl font-bold text-navy-primary mb-2" data-id="element-176">
                  เฉพาะวันนี้เท่านั้น
                </p>
                <div className="text-7xl md:text-8xl font-display font-bold text-gold-accent mb-4" data-id="element-177">
                  ฿649
                </div>
                <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600" data-id="element-178">
                  <span className="flex items-center gap-1" data-id="element-179">
                    <CreditCard className="w-4 h-4" data-id="element-180" />
                    ชำระครั้งเดียว
                  </span>
                  <span className="flex items-center gap-1" data-id="element-181">
                    <Zap className="w-4 h-4" data-id="element-182" />
                    เข้าถึงได้ทันที
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 mb-8 flex items-start gap-3" data-id="element-183">
              <AlertTriangle className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-184" />
              <div data-id="element-185">
                <p className="font-bold text-red-700 mb-1" data-id="element-186">
                  ⚠️ เฉพาะ 200 ท่านแรกเท่านั้น
                </p>
                <p className="text-red-600 text-sm" data-id="element-187">
                  หลังจากนั้นราคากลับไปที่ 1,490฿
                </p>
              </div>
            </div>

            <CTAButton size="large" className="w-full mb-4" data-id="element-188">
              ⚽ ซื้อตอนนี้เลย — 649฿
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600" data-id="element-189">
              <span className="flex items-center gap-1" data-id="element-190">
                <Zap className="w-4 h-4 text-gold-accent" data-id="element-191" />
                เข้าถึงได้ทันที
              </span>
              <span className="flex items-center gap-1" data-id="element-192">
                <CreditCard className="w-4 h-4 text-gold-accent" data-id="element-193" />
                ชำระครั้งเดียว
              </span>
              <span className="flex items-center gap-1" data-id="element-194">
                <Shield className="w-4 h-4 text-gold-accent" data-id="element-195" />
                รับประกัน 7 วัน
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}